module.exports = __webpack_public_path__ + "static/media/failed-capture-three.593de215.png";